/** Sentinel headers consumed by `errorInterceptor`.
 *  Kept in their own module to avoid circular imports between
 *  `api.service.ts` ⇄ `error.interceptor.ts` ⇄ `auth.service.ts`. */

/** Outgoing request opt-out: skip the auto-toast on error. */
export const SUPPRESS_TOAST_HEADER = 'X-Suppress-Toast';
/** Outgoing request opt-out: skip the 401 → /login redirect. */
export const SUPPRESS_AUTH_REDIRECT_HEADER = 'X-Suppress-Auth-Redirect';
